<div class="logo-upload-container">
	<div
		class="upload-area"
		[class.drag-over]="isDragOver"
		[class.has-image]="currentFile"
		(drop)="onDrop($event)"
		(dragover)="onDragOver($event)"
		(dragleave)="onDragLeave($event)"
	>
		<input type="file" #fileInput (change)="onFileSelected($event)" accept="image/*" hidden />

		<!-- Image Preview -->
		<div
			*ngIf="previewUrl || logoUrl"
			class="image-preview"
			(mouseenter)="showOverlay = true"
			(mouseleave)="showOverlay = false"
		>
			<img [src]="previewUrl || logoUrl" alt="Logo preview" class="preview-image" />
			<div class="image-overlay" [class.visible]="showOverlay">
				<button type="button" class="change-btn" (click)="fileInput.click()">Change Logo</button>
				<button type="button" class="remove-btn" (click)="removeImage()">Remove</button>
			</div>
		</div>

		<!-- Placeholder -->
		<div *ngIf="!previewUrl && !logoUrl" class="upload-placeholder" (click)="fileInput.click()">
			<div class="upload-icon">
				<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
					<path
						d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</svg>
			</div>
			<h3>Upload Logo</h3>
			<p>Drag and drop your logo here or click to browse</p>
			<p class="file-info">Supports: JPG, PNG, GIF, SVG (Max: 5MB)</p>
		</div>
	</div>

	<!-- Error -->
	<div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
</div>
